import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/common/arrow_right.svg'


const _withScopeId = n => (_pushScopeId("data-v-9b4ec516"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-form-check" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contact-form-description" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" お問い合わせはメール(年中無休)にて承っております。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" なお、お電話でのお問合せは、営業時間内の対応となりますので、あらかじめご了承ください。 ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "TEL：050-3613-5193（10：00～18：00）※土日祝を除く")
], -1))
const _hoisted_3 = { class: "block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "split-line" }, null, -1))
const _hoisted_5 = { class: "check-field-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "お名前", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "名", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "メールアドレス", -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "電話番号", -1))
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "受注番号", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "お問い合わせの種類", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "お問い合わせの内容", -1))
const _hoisted_16 = { class: "form-check-out-block" }
const _hoisted_17 = {
  key: 0,
  class: "invalid-message"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow-right",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_19 = { class: "back" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_large_heading = _resolveComponent("large-heading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_large_heading, { title: "内容の確認" }),
    _createElementVNode("section", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("dl", _hoisted_5, [
          _createElementVNode("div", null, [
            _hoisted_6,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formData.inquiry_name), 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_7,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formData.inquiry_company_name), 1)
          ]),
          (_ctx.formData.inquiry_email)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("dd", null, _toDisplayString(_ctx.formData.inquiry_email), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.formData.inquiry_tel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("dd", null, _toDisplayString(_ctx.formData.inquiry_tel), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.formData.inquiry_order_no)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("dd", null, _toDisplayString(_ctx.formData.inquiry_order_no), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _hoisted_14,
            _createElementVNode("dd", null, _toDisplayString(_ctx.getContactReasonNameByCode(_ctx.formData.inquiry_type)), 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_15,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formData.inquiry_content), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.errorMessage), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "forward",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCheckOut && _ctx.onCheckOut(...args)))
        }, [
          _createTextVNode(" 上記の内容で送信する "),
          _hoisted_18
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("a", {
            class: "text-link",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBackToInput && _ctx.onBackToInput(...args)))
          }, " ←内容を修正する ")
        ])
      ])
    ])
  ]))
}